// Maps a topic slug (from ?topic= or sessionStorage) to a Romanian
// pre-fill message that seeds the user's first turn with Zenyra.
// Used by entry-point CTAs across the site to make Zenyra feel
// instantly relevant to where the visitor came from.

export const TOPIC_PREFILLS: Record<string, string> = {
  anxietate: "Mă lupt cu anxietatea de o vreme și aș vrea să găsesc un terapeut potrivit.",
  "anxietate-sociala": "Am anxietate socială și mi-ar fi greu să încep cu un terapeut.",
  depresie: "Mă simt apăsat și fără energie de o vreme și caut un terapeut.",
  burnout: "Cred că am ajuns la burnout și nu mai știu cum să continui.",
  "burnout-la-locul-de-munca": "Mă simt epuizat la job și nu mai pot să mă deconectez.",
  "tulburare-de-panica": "Am atacuri de panică în ultima vreme și mă sperie tare.",
  "trauma-si-ptsd": "Am trăit ceva greu și încă mă afectează — vreau să găsesc un terapeut.",
  "stima-de-sine": "Mă lupt cu stima de sine și aș vrea să vorbesc cu cineva.",
  "relatii-si-cuplu": "Am dificultăți în relație și caut un terapeut potrivit pentru cuplu.",
  "dupa-divort": "Trec printr-o despărțire dificilă și am nevoie de cineva care să mă asculte.",
  "terapie-pentru-copii-si-adolescenti": "Caut un terapeut pentru copilul meu — povestesc în numele lui.",
  diaspora: "Sunt în diaspora și caut un terapeut în limba română.",
  adhd: "Cred că am ADHD și caut un terapeut care înțelege asta.",
  emdr: "Aș vrea să încerc EMDR și caut un terapeut specializat.",
  "terapia-schemelor": "Am citit despre terapia schemelor și aș vrea să vorbesc cu cineva.",
  "analiza-tranzactionala": "Sunt curios de analiza tranzacțională și caut un terapeut potrivit.",
  psihanaliza: "Mă interesează psihanaliza și aș vrea o recomandare.",
  doliu: "Am pierdut pe cineva drag și îmi e greu să merg mai departe.",
  insomnie: "Dorm prost de o vreme și aș vrea să vorbesc cu un terapeut despre asta.",
  stres: "Trăiesc cu mult stres în ultima vreme și aș vrea ajutor să îl gestionez.",
  fobii: "Am o frică ce mă limitează și aș vrea să lucrez la ea cu un terapeut.",
  "ganduri-intruzive": "Am gânduri care îmi vin fără să vreau și mă neliniștesc.",
  procrastinare: "Amân lucrurile importante și nu reușesc să ies din cercul ăsta.",
  "sindromul-impostorului": "Am senzația că nu merit ce am realizat și mi-e teamă că se va vedea.",
  dependenta: "Mă lupt cu o dependență și aș vrea să vorbesc cu cineva despre asta.",
  "abuz-emotional": "Cred că am trecut printr-o relație abuzivă emoțional și am nevoie de sprijin.",
  "manipulare-emotionala": "Cred că cineva apropiat mă manipulează emoțional și nu știu ce să fac.",
  "autism-la-adulti": "Mă întreb dacă sunt în spectrul autist și caut un terapeut care înțelege asta.",
  "tulburare-bipolara": "Am perioade cu foarte multă energie urmate de căderi și caut un terapeut.",
  "tulburare-borderline": "Trăiesc emoțiile foarte intens, relațiile mele au de suferit și caut un terapeut.",
};

export function getTopicPrefill(topic: string | null | undefined): string | null {
  if (!topic) return null;
  const key = topic.trim().toLowerCase();
  return TOPIC_PREFILLS[key] ?? null;
}
